// 从身份证号提取生日
export function setBirthFromIdNo(idType, idNo) {
  const birthObj = {}
  if (idType === '1' || idType === '7') {
    const birthYear = idNo.substr(6, 4)
    const birthMonth = idNo.substr(10, 2)
    const birthDay = idNo.substr(12, 2)
    const birthDate = `${birthYear}-${birthMonth}-${birthDay}`
    const sexNo = idNo.substr(16, 1)
    const sex = (sexNo % 2 === 1) || sexNo === '' ? '1' : '2'
    birthObj.birthDate = birthDate
    birthObj.age = getAgeViaDate(birthDate)
    birthObj.sex = sex
    return birthObj
  } else {
    return ''
  }
}
function _pad2(n) { return n < 10 ? '0' + n : n + '' }
  
function dateFormatter(value) {
  const date = {
    'year': new Date(value).getFullYear(),
    'month': _pad2(new Date(value).getMonth() + 1),
    'day': _pad2(new Date(value).getDate())
  }
  return `${date.year}-${date.month}-${date.day}`
}
/**
 * 出生日期获取当前年龄。传入Date类型
 */
export function getAgeViaDate(birthdayDate) {
  return getAgeViaStr(dateFormatter(birthdayDate))
}
/**
 * 出生日期获取当前年龄 YYYY-MM-DD
 */
export function getAgeViaStr(birthdayStr) {
  return agesByBirthday(birthdayStr)
}
/**
 * 根据生日取年龄 TODO 。处理闰年2-29和平年2-28相等的情况。没有测试
 * @param sBirthday 出生日期
 * @returns
 */
export function agesByBirthday (birthday) {  
  if (birthday) {  
    let b;  
    if (birthday instanceof Date) {
      b = dateFormatter(birthday);
    } else if (typeof birthday === 'string') {
      b = birthday.substring(0, 10); // 去掉hh:mm:ss
    } else {
      console.log('birthday is not a string or Date object');
      return '';
    }
    const r = b.match(/^(\d{4})(-|\/)(\d{2})\2(\d{2})$/);
    if (!r) {
      console.log(r,'---->r')
      return ''
    }
    // ======= 直接使用老易捷判断逻辑 ========
    const yearNow = new Date().getFullYear()
    const monthNow = new Date().getMonth()// 月份
    const dayOfMonthNow = new Date().getDate()
    const now = new Date(yearNow, monthNow, dayOfMonthNow)
    const birth = new Date(r[1], r[3] - 1, r[4])
    let age = now.getFullYear() - birth.getFullYear()
    if ((birth.getMonth() > now.getMonth())) {
      age--;
    } else if (birth.getMonth() === now.getMonth()) {
      if (birth.getDate() > now.getDate()) {
        age--;
      }
    }
  
    return age
  }
  return ''
}
    
function isLeapYear(year) {
  return ((year % 4 === 0) && (year % 400 !== 0))
}


// WEBPACK FOOTER //
// ./src/components/utils/dateUtil.js